"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.WooCommerceAPI = {
    getWooCommerceCategories: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/woocommerce/categories").then(function (response) { return response.data; });
    },
    syncWooCommerceProduct: function (companyId, productId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/woocommerce/product/" + productId + "/productSync").then(function (response) { return response.data; });
    },
    syncWooCommerceInventory: function (companyId, productId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/woocommerce/product/" + productId + "/inventorySync");
    },
    deleteWooCommerceProduct: function (companyId, productId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/woocommerce/product/" + productId);
    },
};
//# sourceMappingURL=WooCommerceAPI.js.map